/**
 * Decodes a URL, including the '#' character.
 * @param url
 */
export function decodeUrl(url) {
    if (!url) {
        return '';
    }
    // If url is malformed decoding can throw error
    try {
        // Some of our services (MRU++ v2) encode characters ('&') that cannot be decoded with decodeURI, so we use
        // decodeURIComponent here to fully decode the url.
        return decodeURIComponent(url);
    }
    catch (err) {
        return '';
    }
}
//# sourceMappingURL=decodeUrl.js.map